import '../../../src/styles/healthInfo.css';
import Table from '../../generic_components/Table/Table';

const OfflineDevicesPastWeek = ( {devices} ) => {
    const offlineDevicesPastWeek_columns = [
        { key: 'siteName', label: 'Site name' },
        { key: 'serverName', label: 'Server name' },
        { key: 'cameraName', label: 'Camera Name' },
    ];
    
    const offlineDevicesPastWeek_data = devices.map((device, index) => (
        {
            siteName: device.site,
            serverName: device.serverName,
            cameraName: device.cameraName
        }
    ))

    return (
        <div className='table-container-device' style={{ fontSize: '.85em' }}>        
            <Table 
                columns = {offlineDevicesPastWeek_columns}
                data = {offlineDevicesPastWeek_data}
            />
        </div>
        
    )
}

export default OfflineDevicesPastWeek;